
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import { capitalizeSentence } from '../filters'

import EpbRadio from './radio.component.vue'
import { EpbText } from './shared/epb-text'

export interface RadioItem {
  id: string
  value: string
  checked?: boolean
}

export default defineComponent({
  name: 'EpbRadioGroup',
  components: {
    EpbText,
    EpbRadio,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    items: {
      type: Array as PropType<Array<RadioItem>>,
      required: true,
    },
    labelPosition: {
      type: String, // left | right
      default: 'left',
      validator: position => position === 'left' || position === 'right',
    },
  },
  setup() {
    const baseClass = 'epb-radio-group'

    return {
      baseClass,
      capitalizeSentence,
    }
  },
})
